<template>
  <div class="container">
    <div class="pcinfo">
      <div class="tits">{{ $t('with').title }} <span @click="$router.push({ name: 'WithHistory' })">{{
        $t('with').history }}</span></div>
    <div class="content">
      <van-cell
        is-link
        :title="item.name"
        v-for="item in list"
        :key="item.name"
        @click="toForm(item.name)"
      >
        <template #icon>
          <img :src="item.img" alt="" />
        </template>
      </van-cell>
      <van-cell is-link :title="$t('msgbank').bankCard"  @click="$router.push({ name: 'WithFormBank' })" v-if="basicConfig.IsBank">
        <template #icon>
          <img src="@/assets/new/bankcard.png" alt="" />
        </template>
      </van-cell>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import userApi from '@/api/user'
export default {
  components: {
  },
  computed: {
    ...mapGetters(['basicConfig', 'lang', 'connection'])
  },
  data() {
    return {
      list: [
        {
          img: require('@/assets/new/icon2.png'),
          name: 'USDT'
        },
        {
          img: require('@/assets/new/icon0.png'),
          name: 'ETH'
        },
        {
          img: require('@/assets/new/icon1.png'),
          name: 'BTC'
        }
      ]
    }
  },
  methods: {
    async goServe() {
      let str = this.basicConfig.ServiceUrl
      const res = await this.getUserInfo()
      let userInfo = {
        name: res.UserName,
        uid: res.Code
      }
      if (str.indexOf('?') === -1) {
        str += '?userInfo=' + JSON.stringify(userInfo)
      } else {
        str += '&userInfo=' + JSON.stringify(userInfo)
      }
      str += `&lang=${this.lang === 'zh' ? 'zh-CN' : 'en-US'}`
      location.href = str
    },
    async getUserInfo() {
      const userInfo = await userApi.userInfo()
      return userInfo
    },
    toForm(type) {
      this.$router.push({
        name: 'WithForm',
        query: {
          type
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding: 50px 0;
  width: 100%;

  .pcinfo {
    margin: 0 auto;
    max-width: 1000px;
  }

  .tits {
    display: flex;
    justify-content: space-between;
    font-size: 20px;
    font-weight: bold;

    span {
      font-size: 15px;
      font-weight: normal;

      &:hover {
        color: #f2ba18;
      }
    }
  }
  .van-cell {
    img {
      width: 25px;
      height: 26px;
      margin-right: 10px;
    }
  }
  .content {
    background: #fff;
    margin: 15px 0 30px;
    border-radius: 5px;
    overflow: hidden;
  }
}
</style>
